export default "__VITE_ASSET__DAHchb9H__"